import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import {
  RmSelectRegisterComponent,
  SearchFilterPipe,
} from './rm-select-register.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RomaToolTipModule } from '@web-frontend/shared/directives/roma-tooltip';
import { ImageModule } from '@web-frontend/shared/pipes/image';
import { RmBadgeModule } from '@web-frontend/shared/components/globals/rm-badge';
import { PermissionsModule } from '../../permissions';

@NgModule({
  declarations: [RmSelectRegisterComponent, SearchFilterPipe],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatProgressSpinnerModule,
    MatCheckboxModule,
    RomaToolTipModule,
    ImageModule.forRoot(),
    RmBadgeModule,
    PermissionsModule,
  ],
  providers: [TitleCasePipe],
  exports: [RmSelectRegisterComponent],
})
export class RmSelectRegisterModule {}
